module.exports = __webpack_public_path__ + "static/img/funreport-qrcode.351260c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/funreport-qrcode.png
// module id = 18
// module chunks = 2